import {useEffect} from 'react'
import {useSelector, shallowEqual} from 'react-redux'
import actions from 'redux-auto'

const loadingSelector = state => state.dashboardAusbilder.isLoading
const ausbildungsplanSelector = state => state.dashboardAusbilder.ausbildungsplan
const ausbildungsnachweiseSelector = state => state.dashboardAusbilder.ausbildungsnachweise
const praxisaufgabenSelector = state => state.dashboardAusbilder.praxisaufgaben

export default function useAusbilderDashboardData() {
  const isLoading = useSelector(loadingSelector)
  const ausbildungsplanModel = useSelector(ausbildungsplanSelector, shallowEqual)
  const ausbildungsnachweiseModel = useSelector(ausbildungsnachweiseSelector, shallowEqual)
  const praxisaufgabenModel = useSelector(praxisaufgabenSelector, shallowEqual)

  useEffect(() => {
    actions.dashboardAusbilder.getDashboardAusbilderData()
  }, [])

  return {
    isLoading,
    ausbildungsplanModel,
    ausbildungsnachweiseModel,
    praxisaufgabenModel,
  }
}
